import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useQuotePackagesEditingModeStyles = createStyles(
  ({ css, token }) => ({
    quotesCalculateButton: css`
      &&& {
        height: 20px;
        width: 90px;
        font-size: ${ThemeFont.FONT_SIZE_SM_MINUS}px;
      }
    `,
    newQuotePackageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderTop: `1px solid ${ThemeColors.COLOR_GREY7_8}`,
      borderBottom: `1px solid ${token.colorWhite}`,
      color: ThemeColors.COLOR_GREY3,
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontSize: 17,
      fontWeight: 700,
      height: 30,
      marginBottom: ThemeSpaces.SPACE_NORM0_5,
      paddingLeft: ThemeSpaces.SPACE_NORM,
      paddingRight: ThemeSpaces.SPACE_NORM_20,
    },
    newShipmentPackageListForm: {
      '.fa-plus-square, .fa-times': {
        paddingLeft: ThemeSpaces.SPACE_NORM0_5,
        paddingRight: ThemeSpaces.SPACE_NORM,
        fontSize: token.fontSizeLG,

        [`@media (max-width: ${token.screenXLMax}px)`]: {
          paddingRight: ThemeSpaces.SPACE_NORM0_5,
        },
      },
    },
    quotePackageWeightResult: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingRight: ThemeSpaces.SPACE_NORM,
      paddingLeft: ThemeSpaces.SPACE_NORM_20,
      marginBottom: ThemeSpaces.SPACE_NORM0_5,

      [`@media (max-width: ${token.screenSMMax}px)`]: {
        paddingLeft: ThemeSpaces.SPACE_NORM,
      },

      [`@media (min-width: ${token.screenXSMin}px) and (max-width: ${token.screenXLMax}px)`]:
        {
          '.FloatingLabelWrapper.has-value > label, .FloatingLabelWrapper > label':
            {
              left: token.paddingSM,
            },
          '.FloatingLabelWrapper > .ant-input-number > * > input': {
            paddingLeft: token.paddingSM,
          },
        },
    },
    quotePackagesInputs: {
      '&&': {
        marginBottom: ThemeSpaces.SPACE_NORM,
      },
      paddingLeft: ThemeSpaces.SPACE_NORM,
      paddingRight: ThemeSpaces.SPACE_NORM,

      [`@media (max-width: ${token.screenSMMax}px)`]: {
        '.ant-col-12': {
          '&:first-child': {
            paddingRight: `${ThemeSpaces.SPACE_NORM0_5}px !important`,
          },
          '&:last-child': {
            paddingLeft: `${ThemeSpaces.SPACE_NORM0_5}px !important`,
          },
        },
      },

      [`@media (min-width: ${token.screenMDMin}px)`]: {
        paddingLeft: ThemeSpaces.SPACE_NORM_20,
        paddingRight: ThemeSpaces.SPACE_NORM_20,
      },

      [`@media (max-width: ${token.screenXLMax}px)`]: {
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      },

      [`@media (min-width: ${token.screenXSMin}px) and (max-width: ${token.screenXLMax}px)`]:
        {
          '&.quote-packages-dim-inputs .FloatingLabelWrapper.has-value > label, &.quote-packages-dim-inputs .FloatingLabelWrapper > label':
            {
              left: token.paddingSM,
            },
          '&.quote-packages-dim-inputs .FloatingLabelWrapper > .ant-input-number > * > input':
            {
              paddingLeft: token.paddingSM,
            },
        },

      '.SymbolCol.DimensionSeparator': {
        width: 'auto !important',
      },
    },
    quoteWeightInput: {
      '& > .ant-col:first-child': {
        paddingRight: '0 !important',
      },
    },
    hasError: {
      '.ant-input-number': {
        border: `1px solid ${token.colorPrimary}`,
      },
    },
    quotePackageButton: {
      display: 'flex',
      alignItems: 'center',

      '.fa-times-circle': {
        marginLeft: ThemeSpaces.SPACE_NORM,
        fontSize: 18,
        color: token.colorPrimary,
        cursor: 'pointer',
      },
    },
  })
);
